import { ComumModule } from './../comum/comum.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { routing } from './../rotas';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth-guard.service';
import { AuthTokenInterceptor } from './auth-token.interceptor';
import { UserLoginComponent } from './user-login/user-login.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { UsuarioService } from '../usuario/usuario.service';
import { PermissoesAcessoService } from '../permissoes-acesso/permissoes-acesso.service';
import { ClienteService } from '../cliente/cliente.service';

export const firebaseConfig = {
  apiKey: 'AIzaSyAZNS4hPbkjwSJtAg_SjUMHY7Md2gvMDrg',
  authDomain: 'flag-b4dc1.firebaseapp.com',
  databaseURL: 'https://flag-b4dc1.firebaseio.com',
  projectId: 'flag-b4dc1',
  storageBucket: 'flag-b4dc1.appspot.com',
  messagingSenderId: '141709752924'
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ComumModule,
    HttpClientModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    routing,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    })
  ],
  declarations: [
    UserLoginComponent
  ],
  providers: [AuthService, AuthGuard, CookieService, UsuarioService, PermissoesAcessoService, ClienteService, {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthTokenInterceptor,
    multi: true
  }],
  exports: [UserLoginComponent]
})
export class AuthModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/auth/auth.module.ts